import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { fetchWithAuth } from '../../utils/fetchWithAuth';
import { useUser } from '../../context/UserContext';
import FaceVerificationPage from '../Admin/FaceVerificationPage';
import Button from '../UI/Button';
import { useForm } from 'react-hook-form';
const CheckpointVerification = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [checkpoint, setCheckpoint] = useState(null);
    const [verificationResult, setVerificationResult] = useState(null);
    const { logout } = useUser();
	const [isLogoutConfirmOpen, setIsLogoutConfirmOpen] = useState(false);
	const [authError, setAuthError] = useState('');
	const [authLoading, setAuthLoading] = useState(false);
	const {
		register,
		handleSubmit,
		formState: { errors },
		reset
	} = useForm();
	

    useEffect(() => {
        fetchCheckpoint();
    }, [id]);

    const fetchCheckpoint = async () => {
        try {
            const res = await fetchWithAuth(
                `${process.env.REACT_APP_API_URL}/checkpoints/${id}`,
                { method: 'GET' },
                logout
            );
            const data = await res.json();
            setCheckpoint(data);
        } catch (error) {
            console.error('Ошибка загрузки КПП:', error);
        }
    };

    const handleVerificationSuccess = async (userData) => {
        setVerificationResult({
            success: true,
            user: userData,
            message: `✅ ${checkpoint.type === 'entry' ? 'Вход' : 'Выход'} успешно зарегистрирован`
        });
    };

    if (!checkpoint) {
        return <div className="p-6">Загрузка...</div>;
    }

    if (!checkpoint.isActive) {
        return (
            <div className="p-6">
                <div className="bg-red-500 text-white p-4 rounded-lg mb-4">
                    КПП неактивен. Обратитесь к администратору.
                </div>
                <Button onClick={() => navigate('/checkpoints')} variant="primary">
                    Вернуться к списку КПП
                </Button>
            </div>
        );
    }

	const handleLogoutConfirm = async (formData) => {
		setAuthError('');
		setAuthLoading(true);
		try {
			const res = await fetch(`${process.env.REACT_APP_API_URL}/auth/check-admin`, {
				method: "POST",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify(formData)
			});
	
			if (!res.ok) {
				const data = await res.json();
				throw new Error(data.message || "Ошибка проверки");
			}
	
			reset(); // очистить поля формы
			navigate('/');
		} catch (err) {
			setAuthError(err.message || 'Ошибка авторизации');
		} finally {
			setAuthLoading(false);
		}
	};
	
	
    return (
        <div className="p-9 fixed inset-0 bg-black bg-opacity-90 flex flex-col items-center justify-center">
            <div className="mb-6 w-full max-w-5xl flex flex-row justify-between bg-[#252526] p-4 rounded-lg border border-[#3E3E42]">
				<div className="flex justify-start flex-col">
                	<h2 className="text-2xl font-semibold mb-2 text-[#CCCCCC]">{checkpoint.name}</h2>
                	<p className="text-gray-400">{checkpoint.description}</p>
                	<p className="text-gray-400">Локация: {checkpoint.location}</p>
                	<p className="text-gray-400">Тип: {checkpoint.type === 'entry' ? 'Вход' : 'Выход'}</p>
				</div>
				<div className="flex justify-end flex-col gap-2">
					<div className="flex justify-end">
						<Button onClick={() => setIsLogoutConfirmOpen(true)} variant="danger">Выйти</Button>
			    	</div>
					{verificationResult && (
					
                	<div className={`mb-6 p-4 rounded-lg ${
                	    verificationResult.success 
                	        ? 'bg-green-500 text-white' 
                	        : 'bg-red-500 text-white'
                	}`}>
                	    {verificationResult.message}
                	    {verificationResult.user && (
                	        <div className="mt-2">
                	            <p>Пользователь: {verificationResult.user.lastName} {verificationResult.user.fullName}  {verificationResult.user.firstName}  
									( {verificationResult.user.username} ) 
								</p>
                	        </div>
                	    )}
                	</div>

            		)}
				</div>
            </div>
            <div className="w-full max-w-5xl bg-[#252526] p-4 rounded-lg border border-[#3E3E42]">
                <FaceVerificationPage 
                    type={checkpoint.type}
                    location={checkpoint.location}
                    checkpoint={checkpoint}
                    onVerificationSuccess={handleVerificationSuccess}
                />
            </div>
			{isLogoutConfirmOpen && (
    		<div className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50">
    		    <div className="bg-[#1E1E1E] p-6 rounded-lg w-full max-w-md border border-[#3E3E42]">
    		        <h3 className="text-lg font-semibold text-white mb-4">Подтвердите выход</h3>
    		        {authError && <div className="text-red-500 mb-2">{authError}</div>}

    		        <form onSubmit={handleSubmit(handleLogoutConfirm)}>
    		            <div className="mb-3">
    		                <input
    		                    {...register('username', { required: 'Введите логин' })}
    		                    placeholder="Логин"
    		                    className="w-full px-3 py-2 rounded bg-[#2D2D30] border border-[#3E3E42] text-white"
    		                />
    		                {errors.username && <p className="text-red-400 text-sm mt-1">{errors.username.message}</p>}
    		            </div>

    		            <div className="mb-4">
    		                <input
    		                    type="password"
    		                    {...register('password', { required: 'Введите пароль' })}
    		                    placeholder="Пароль"
    		                    className="w-full px-3 py-2 rounded bg-[#2D2D30] border border-[#3E3E42] text-white"
    		                />
    		                {errors.password && <p className="text-red-400 text-sm mt-1">{errors.password.message}</p>}
    		            </div>

    		            <div className="flex justify-end gap-2">
    		                <Button type="button" variant="cancel" onClick={() => {
    		                    reset();
    		                    setIsLogoutConfirmOpen(false);
    		                    setAuthError('');
    		                }}>Отмена</Button>
    		                <Button type="submit" variant="danger" disabled={authLoading}>
    		                    {authLoading ? 'Проверка...' : 'Выйти'}
    		                </Button>
    		            </div>
    		        </form>
    		    </div>
    		</div>
            )}		
        </div>
    );
};

export default CheckpointVerification; 